import { page, pageVisible, loading } from '../../main/webgiving-main.less';
import { classNames } from '../../../Shared/utils/classnames';

export function getPageClasses(pageShouldBeVisible: boolean, isLoading: boolean, showingNotice?: boolean) {
    return classNames(page, {
        [pageVisible]: pageShouldBeVisible,
        [loading]: isLoading && !showingNotice,
    });
}
